// database.js

const iphoneDatabase = [
    {
        product_id: "iPhone SE",
      product_url: "iPhone SE",
      product_name: "iPhone SE",
      product_img: "https://www.apple.com/v/iphone/home/aj/images/overview/hero/hero_iphone_se__barrz3dlvxea_small_2x.jpg",
      product_brief_description: "Lots to love. Less to spend.",
      starting_price: "$399",
      price_range: "From $9.54/mo. or $229 with trade-in.*",
      product_description:"iPhone SE packs our most powerful chip into our most popular size at our most affordable price. Itâ€™s just what youâ€™ve been waiting for.",
    },
    {
        product_id: "iPhone 11",
      product_url: "iPhone 11",
      product_name: "iPhone 11",
      product_img: "https://www.apple.com/v/iphone/home/aj/images/overview/hero/hero_iphone_11__bsnxu2gpf98i_small_2x.jpg",
      product_brief_description: "Lots to love. Less to spend.",
      starting_price: "$449",
      price_range: "From $18.70/mo. or $449 with trade-in.*",
      product_description:"You can either pay for your new iPhone in full or pay monthly with carrier financing, iPhone Payments, the iPhone Upgrade Program, and now Apple Card Monthly Installments. Your carrier service plan will be charged separately. Just choose the option that works for you."
    },
    {
        product_id: "iPhone 11 Pro",
      product_url: "iPhone 11 Pro",
      product_name: "iPhone 11 Pro",
      product_img: "https://www.apple.com/v/iphone/home/aj/images/overview/hero/hero_iphone_11_pro__d2lf9zrtcv8m_small_2x.jpg",
      product_brief_description: "Pro cameras. Pro display. Pro performance.",
      starting_price: "$679",
      price_range: "From $28.29/mo. or $679 with trade-in.*",
      product_description:"A transformative tripleâ€‘camera system that adds tons of capability without complexity. An unprecedented leap in battery life. And a mindâ€‘blowing chip that doubles down on machine learning and pushes the boundaries of what a smartphone can do. Welcome to the first iPhone powerful enough to be called Pro.",
    },
  ];
  
  export default iphoneDatabase;
  